<template>
    <input ref="inputRef" type="text" class="input currency-input"/>
  </template>
  
  <script>
  import { useCurrencyInput } from 'vue-currency-input'
  
  export default {
    name: 'CurrencyInput',
    props: {
      modelValue: Number,
      options: Object
    },
    setup(props) {
      const { inputRef } = useCurrencyInput(props.options)
  
      return { inputRef }
    }
  }
</script>

<style>
    input.currency-input {
        font-size: 14px;
        vertical-align: middle;
        height: auto;
        width: auto;
    }
</style>